import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RiLock2Line } from "react-icons/ri";
import { MdOutlineMailOutline } from "react-icons/md";
import { PiSignIn } from "react-icons/pi";

import Spinner from "../../../shared-components/Spinner/Spinner";
import { loginUser } from "../../../actions/userActions";
import { USER_REGISTER_RESET } from "../../../constants/userConstants";
import { getAllServiceProviders } from "../../../actions/serviceProviderActions";
import AuthLayout from "../shared/AuthLayout";
import AuthInput from "../shared/AuthInput";

const SignIn = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { loading, user, error } = useSelector((state) => state.userLogin);
  const { loading: loadingInfo } = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch({ type: USER_REGISTER_RESET });
    if (user) {
      if (user.service_provider && user.is_provider_verified) {
        dispatch(getAllServiceProviders());
        navigate("/service-provider-dashboard/analytics");
      } else if (user.service_provider && !user.is_provider_verified) {
        navigate("/provider-details-verification");
      } else {
        navigate("/");
      }
    }
    if (error) {
      toast.error(error);
    }
  }, [user, error]);

  //   Change Input Handler
  const changeInputHandler = (event) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [event.target.id]: event.target.value,
      };
    });
  };

  //   Form Submit Handler
  const submitFormHandler = (event) => {
    event.preventDefault();
    const localUser = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;

    if (localUser !== null) {
      window.location.reload(false);
      return;
    }
    if (formData.email === "" || formData.password === "") {
      return toast.error("Please enter both your email and password");
    }
    dispatch(loginUser(formData));
  };

  return loading || loadingInfo ? (
    <Spinner />
  ) : (
    <AuthLayout
      title="Welcome back"
      subtitle="Sign in to manage your storage, bookings, and account."
      side={{
        heading: (
          <>
            Storage, <span>simplified.</span>
          </>
        ),
        points: [
          "Find and book storage units near you",
          "Track your bookings and orders in one place",
          "Providers: manage listings, orders, and payouts from your dashboard",
        ],
      }}
    >
      <div className="auth-card">
        <form onSubmit={submitFormHandler}>
          <AuthInput
            label="Email address"
            id="email"
            type="email"
            value={formData.email}
            onChange={changeInputHandler}
            icon={<MdOutlineMailOutline size={20} />}
            placeholder="you@example.com"
            autoComplete="email"
          />
          <AuthInput
            label="Password"
            id="password"
            type="password"
            value={formData.password}
            onChange={changeInputHandler}
            icon={<RiLock2Line size={20} />}
            placeholder="Your password"
            autoComplete="current-password"
          />

          <div className="d-flex justify-content-end mb-3">
            <Link
              to="/forgot-password"
              className="a-font"
              style={{ fontSize: "14px", fontWeight: 600, color: "#eab800", textDecoration: "none" }}
            >
              Forgot password?
            </Link>
          </div>

          <button type="submit" className="a-font auth-submit">
            Sign In <PiSignIn size={18} />
          </button>
        </form>
      </div>

      <Link to="/sign-up" className="a-font auth-footer-link">
        New to FindxStorage? <span>Create an account</span>
      </Link>
    </AuthLayout>
  );
};

export default SignIn;
